/**
 * Updates the dimensions whenever the slider size number changes.
 *
 * Notes:
 * - in theory, label_preview.js could obviate the need for watching the slider values,
 *   since it watches for changes or resizes to the label preview itself. However, I figured let's
 *   keep the binding to the sliders as well - at first, anyway - to make sure it's snappy and reliable.
 * - if we decide to "hide" the slider size numbers, which was one possibility we discussed,
 *   we would want to still have `labels/slider.js` updating #slider-size and #slider-size2 with numbers,
 *   just not displayed; otherwise we'd want to bind to size changes on #label-and-claim-div.
 */

import { SLIDER_SIZE_1, SLIDER_SIZE_2 } from "../constants";
import { updateDisplayedDimensions } from "../display";
import { debugLog, getElement } from "../utils";

export const bindSliderChanges = () => {
  const callback = () => {
    debugLog("[bindSliderChanges:callback] Calling updateDisplayedDimensions ...");
    updateDisplayedDimensions();
  };
  const observer = new MutationObserver(callback);

  for (const selector of [SLIDER_SIZE_1, SLIDER_SIZE_2]) {
    const el = getElement(selector);
    if (el) {
      observer.observe(el, {
        childList: true,
      });
    }
  }

  debugLog("[bindSliderChanges] Mutation observers initialized.");
};
